<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelTipoTransacaoBancaria"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'posicao'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_tipo_transacao_bancaria', null);
        return;
      }
      if (this.posicao != undefined) {
        this.$emit('selectChange', 'id_tipo_transacao_bancaria', { e: e.id, index: this.posicao });
      } else {
        this.$emit('selectChange', 'id_tipo_transacao_bancaria', e.id);
      }

      this.$emit('focus');
    },
    labelTipoTransacaoBancaria({ nome }) {
      return nome;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('tipo_transacao_bancaria', {
          columns: 'id, nome',
          order: 'id'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          res.data.forEach((element) => {
            if (element.nome != 'Não Definido') {
              element.nome = this.$i18n.t(element.nome);
              this.options.push(element);
            }
          });
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
